export default __webpack_public_path__ + "static/media/productHowItWorks3.aaa9bf47.svg";